import React, { createContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Divider, Grid, Typography } from "@mui/material";
import EmployeeAddress from "./EmployeeAddress/EmployeeAddress";
import EmployeeBankAccount from "./EmployeeBankAccount/EmployeeBankAccount";
import EmployeeDependents from "./EmployeeDependents/EmployeeDependents";
import EmployeeChangingDocuments from "./EmployeeChangingDocuments/EmployeeChangingDocuments";
import { EmployeeDataProps } from "./interfaces";

import { SPACING } from "../../_globalStore/redux/reducers/Theme/themeConstants";
import LoadingOverlay from "../LoadingOverlay/LoadingOverlay";
import AddNewDocument from "../AddNewDocument/AddNewDocument";
import { DOCUMENT_CATEGORIES } from "../../utils/constants/constants";
import { DocumentCategoryRef } from "../../models/document-categories";
import { useAppSelector } from "../../custom-hooks/redux/redux";
import { isTabAuthorized } from "../../custom-hooks/useAuthorization/useAuthorization";
import { MyDataLinks } from "../../widgetLink";
import { NotAuthorizedPage } from "../../reusable-components/NotAuthorizedPage/NotAuthorizedPage";
import useAbortableLoadResponse from "../../custom-hooks/useAbortableLoadResponse/useAbortableLoadResponse";
import { EmployeeDTO, EmployeeRef } from "../../models/employees";
import { EmployeesApiService } from "../../services/employees/employees-api.service";
import EmployeeSelectionAndMutation from "../../views/my-data-and-documents/Employee/EmployeeSelectionAndMutation";
import { MyDocumentsLinks } from "../../widgetLink";

export const EmployeeDataContext = createContext<EmployeeDataProps>({
  employee: null,
  forManager: false,
});
const EmployeePersonalData = ({ employee, forManager }: { employee: EmployeeDTO | null; forManager: boolean }) => {
  return (
    <EmployeeDataContext.Provider value={{ employee, forManager }}>
      <Grid
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "15px",
          minWidth: "40%",
        }}
      >
        <EmployeeAddress />

        <Divider
          orientation="horizontal"
          style={{ width: "90%", alignSelf: "center" }}
        />
        <EmployeeBankAccount />
        <Divider
          orientation="horizontal"
          style={{ width: "90%", alignSelf: "center" }}
        />

        <EmployeeDependents />
      </Grid>
    </EmployeeDataContext.Provider>
  );
};
export default EmployeePersonalData;
